import { Footer as MouseFooter } from 'mouse-user-interface';
import styles from './Footer.module.scss';

function Footer() {
    return (
        <MouseFooter
            columns={1}
        >
            <div className={styles.footer}>
                &copy; {new Date().getFullYear()} &#8226; MouseUI
            </div>
        </MouseFooter>
    );
}

export default Footer;
